import React, { FC, useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import loadable from '@loadable/component';
import StateInterface, { BellaThunkDispatch } from '../../../../redux/types';
import { AnimationEntryExit, OverlayId } from '../../types';
import { apiResendDOIConfirmation } from '../../../../redux/user/clubRegistration/actions';
import useGa from '../../../../hooks/useGa';
import { DoiActionProps } from './DOIContent';
import { getOverlayById } from 'Client/redux/header/overlays/selectors';
import { ClubRegistrationError } from 'Client/redux/user/types';

const DOIOverlay = loadable(() => import('./DOIOverlay'));

export interface ReduxDispatchProps {
    resendDoiEmail: (isNewsletterSubscribed: boolean) => void;
}

export interface ReduxStateProps {
    error?: ClubRegistrationError;
    message?: String;
    animateStyle: AnimationEntryExit;
    isDOIActive: boolean;
}

export interface Props extends ReduxStateProps, ReduxDispatchProps {}

const ConnectedDOIOverlay: FC<Props> = ({ isDOIActive, animateStyle, resendDoiEmail, error, message }) => {
    const gaTracker = useGa();
    const email = useSelector<StateInterface, string | undefined>(state => state.appShellLogin.data?.email) || '';

    useEffect(() => {
        if (isDOIActive) {
            gaTracker.shopToClub.trackDoiOverlayShown();
        }
    }, [gaTracker.shopToClub, isDOIActive]);

    return isDOIActive ? (
        <DOIOverlay
            animateStyle={animateStyle}
            resendDoiEmail={resendDoiEmail}
            email={email}
            error={error}
            message={message}
        />
    ) : null;
};

const mapStateToProps = (state: StateInterface): ReduxStateProps => {
    const { doiError: error, doiMessage: message } = state.clubRegistration.doi;
    const { isActive: isDOIActive, contentAnimate: animateStyle = AnimationEntryExit.ENTRY } = getOverlayById(
        state.header.overlays,
        OverlayId.DOUBLE_OPT_IN_OVERLAY
    );

    return {
        error,
        message,
        isDOIActive,
        animateStyle,
    };
};

const mapDispatchToProps = (dispatch: BellaThunkDispatch): DoiActionProps => ({
    resendDoiEmail: (isNewsletterSubscribed: boolean) => {
        dispatch(apiResendDOIConfirmation(isNewsletterSubscribed));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(ConnectedDOIOverlay);
